var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTumblr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "94.955px",
    height: "94.954px",
    viewBox: "0 0 94.955 94.954",
    style: {
      enableBackground: "new 0 0 94.955 94.954"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.589,76.04c-1.395,0.306-16.695,6.845-16.695-9.084c-0.029-6.011-0.006-12.022-0.006-18.033c0-2.651,0-5.855,0-8.953 c6.407,0,12.226,0,17.932,0V24.506c-6.028,0-11.734,0-17.836,0c0-8.038,0-16.277,0-24.506c-2.814,0-15.247,0-15.247,0 s-0.106,2.699-1.094,6.677c-2.577,9.132-9.575,17.751-17.683,20.061c0,4.663,0,8.775,0,13.438c3.65,0,6.676,0,10.732,0 l-0.008,28.769c0,35.523,40.497,25.674,44.309,21.64L70.589,76.04z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTumblr);
export default __webpack_public_path__ + "static/media/tumblr.8799a17c84909a448b055ca65a561e20.svg";
export { ForwardRef as ReactComponent };